
import React from 'react';

export const Services: React.FC = () => {
  return (
    <section id="services" className="py-16 sm:py-20 bg-white overflow-hidden">
      <div className="container mx-auto px-4 max-w-full">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-4 sm:mb-6 break-words">
            サービス内容
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed break-words">
            ご利用者様のニーズに合わせた
            幅広いサービスを提供しております。
            専門的な知識と豊富な経験を持つ
            スタッフがサポートいたします。
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
          <div className="bg-gray-50 p-6 sm:p-8 rounded-lg shadow-md">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-pink-100 rounded-full flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-home-heart-fill text-pink-600 text-2xl sm:text-3xl"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4 break-words">身体介護</h3>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed break-words">
              入浴介助、排泄介助、食事介助、
              移乗介助など、
              日常生活に必要な身体介護サービスを
              提供いたします。
            </p>
          </div>

          <div className="bg-gray-50 p-6 sm:p-8 rounded-lg shadow-md">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-pink-100 rounded-full flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-shopping-cart-fill text-pink-600 text-2xl sm:text-3xl"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4 break-words">生活援助</h3>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed break-words">
              掃除、洗濯、買い物、調理など、
              日常生活を送る上で必要な
              家事援助サービスを提供いたします。
            </p>
          </div>

          <div className="bg-gray-50 p-6 sm:p-8 rounded-lg shadow-md">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-pink-100 rounded-full flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-stethoscope-fill text-pink-600 text-2xl sm:text-3xl"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4 break-words">医療連携</h3>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed break-words">
              医師や看護師、ケアマネージャーと連携し、
              総合的なケアプランに基づいた
              サービスを提供いたします。
            </p>
          </div>

          <div className="bg-gray-50 p-6 sm:p-8 rounded-lg shadow-md">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-pink-100 rounded-full flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-time-fill text-pink-600 text-2xl sm:text-3xl"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4 break-words">24時間対応</h3>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed break-words">
              緊急時にも迅速に対応できるよう、
              24時間体制でサポートいたします。
            </p>
          </div>

          <div className="bg-gray-50 p-6 sm:p-8 rounded-lg shadow-md">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-pink-100 rounded-full flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-user-heart-fill text-pink-600 text-2xl sm:text-3xl"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4 break-words">認知症ケア</h3>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed break-words">
              認知症の方にも安心してご利用いただけるよう、
              専門的な知識を持つスタッフが
              ケアいたします。
            </p>
          </div>

          <div className="bg-gray-50 p-6 sm:p-8 rounded-lg shadow-md sm:col-span-2 lg:col-span-1">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-pink-100 rounded-full flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-chat-heart-fill text-pink-600 text-2xl sm:text-3xl"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-3 sm:mb-4 break-words">相談・相談支援</h3>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed break-words">
              介護に関するご相談やお悩みに
              親身になってお答えし、
              最適なサービスをご提案いたします。
            </p>
          </div>
        </div>

        <div className="bg-pink-50 p-6 sm:p-8 rounded-lg">
          <div className="text-center">
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-3 sm:mb-4 break-words">サービス提供地域</h3>
            <p className="text-lg sm:text-xl text-gray-700 mb-4 sm:mb-6 break-words">
              福島市内全域にてサービスを提供しております。
            </p>
            <div className="flex items-center justify-center flex-wrap min-w-0">
              <div className="w-6 h-6 sm:w-8 sm:h-8 bg-pink-100 rounded-full flex items-center justify-center mr-2 sm:mr-3 flex-shrink-0">
                <i className="ri-map-pin-fill text-pink-600 text-lg sm:text-xl"></i>
              </div>
              <span className="text-base sm:text-lg text-gray-700 text-center break-words min-w-0">
                詳しい対応エリアについては
                お気軽にお問い合わせください
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
